<script>
    import {twMerge} from "$m7-library/lib/twMerge";

    const {class: cls = "", width = "24", height = "24"} = $props()
</script>

<svg class={twMerge("tw:text-cyprus tw:h-6 tw:w-6", cls)} width="{width}" height="{height}" viewBox="0 0 18.75 18.75" fill="none"
     xmlns="http://www.w3.org/2000/svg">
    <path d="M3.12376 10.9375L10.2488 1.6953L9.42063 6.7578H15.6238L8.49876 17.0547L9.32688 11.9922H3.12376Z" stroke="currentColor" stroke-width="1.5625" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
